import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ResourceTableBody from '@presentational/ResourceTableBody';
import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import { ta } from 'utils';

const propTypes = {
  groupedItems: PropTypes.arrayOf(PropTypes.shape({
    transfers: PropTypes.arrayOf(PropTypes.shape({
      invoice_number: PropTypes.string.isRequired,
      order_date_human: PropTypes.string.isRequired,
      vendor: PropTypes.string.isRequired,
      total_amount_formatted: PropTypes.string.isRequired,
    })),
    seller: PropTypes.object.isRequired,
    total_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    total_amount_formatted: PropTypes.string.isRequired,
    currency_symbol: PropTypes.string.isRequired,
  })),
}

const defaultProps = {

}

const saleReportItemsCols = [
  { size: 3, header: ta("transfer.vendor"), accessor: "vendor" },
  { size: 3, header: ta("sale_report.transfer_date"), accessor: "order_date_human" },
  { size: 4, header: ta("transfer.invoice_number"), accessor: "invoice_number" },
  { size: 2, header: "Total", accessor: "total_amount_formatted" },
];

const SalesByTransfers = (props) => {
  console.log("Super what", props)
  return (
    <div>
      <ResourceTableHeaders
        columnsInfo={saleReportItemsCols}
      />
      { props.groupedItems.map( ({transfers, seller, total_amount_formatted, currency_symbol }, index)  =>
        <div key={index}>
          <ResourceTableBody
            columnsInfo={saleReportItemsCols}
            items={ transfers }
            itemURL={null}
          />
          <div className="container-fluid pv15 bg-gray mb40">
            <div className="row">

              <div className="col-md-10">
                Total por abonar a  <strong>{ seller.vendor }</strong>
              </div>
              <div className="col-md-2">
                { total_amount_formatted }
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  )
};

SalesByTransfers.propTypes = propTypes;
SalesByTransfers.defaultProps = defaultProps;

export default SalesByTransfers;